import { createReduxModule } from "hooks-for-redux";

export const ADS_PROVIDER_PLAYWIRE = "playwire";
export const ADS_PROVIDER_ADSENSE = "adsense";
export const ADS_PROVIDER_YANDEX = "yandex";
export const ADS_PROVIDER_GAM = "gam";

const initialState = {
  playersOnline: null,
  loadingBarVisible: false,
  adsVisible: false,
  adsProvider: null,
  gamePath: "/game",
  lobbyPath: "/lobby",
  iframeMode: false,
  adSenseVideo: false,
  imaLoaded: false,
};

export const [
  useSiteData,
  {
    setLoadingBar,
    setPlayersOnline,
    setAdsenseVideo,
    setImaLoaded,
    setAdsProvider,
    setIframeMode,
  },
  siteDataStore,
] = createReduxModule("siteData", initialState, {
  setLoadingBar: (state, loadingBarVisible) => ({
    ...state,
    loadingBarVisible,
  }),
  setPlayersOnline: (state, playersOnline) => ({
    ...state,
    playersOnline,
  }),
  setAdsenseVideo: (state) => ({
    ...state,
    adSenseVideo: true,
  }),
  setImaLoaded: (state) => ({
    ...state,
    imaLoaded: true,
  }),
  setAdsProvider: (state, adsProvider) => ({
    ...state,
    adsProvider,
    adsVisible: true,
  }),
  setIframeMode: (state) => ({
    ...state,
    gamePath: "/iframe/game",
    lobbyPath: "/iframe/lobby",
    iframeMode: true,
  }),
});
